

import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaGithub } from 'react-icons/fa';
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from 'react-icons/ai';
import { Swiper, SwiperSlide } from 'swiper/react';

import { FreeMode, Pagination, Navigation, Thumbs } from 'swiper/modules';


// // Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/pagination';






const ProjectDetails = () => {
    const location = useLocation();
    const { project } = location.state; // Destructure project from state

    const [modal, setModal] = useState({ isOpen: false, src: '', title: '', isFullscreen: false });


    if (!project) {
        return <div className="text-center p-10 text-xl">Project not found</div>;
    };


    const openModal = (image) => {
        setModal({ isOpen: true, src: image.url, title: image.title, isFullscreen: false });
    };

    const closeModal = () => {
        setModal({ isOpen: false, src: '', title: '', isFullscreen: false });
    };

    const toggleFullscreen = () => {
        setModal((prev) => ({ ...prev, isFullscreen: !prev.isFullscreen }));
    };

    return (
        <div className="flex flex-col w-full mt-10">
            {/* Banner Section */}
            <div className="relative w-full h-[300px] bg-black/80 border-b-white border-b-2 border-dotted">
                <img
                    src={project.imageSlider?.[1]?.url}
                    alt={project.title}
                    className="w-full h-full object-cover brightness-75"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                    <h1 className="text-4xl font-bold text-white shadow-lg">
                        {project.title}
                    </h1>
                </div>
            </div>

            {/* Content Section */}
            <div className="p-6 lg:max-w-5xl mx-auto w-full">
                <div className="flex flex-col sm:flex-row justify-around items-start ">
                    <div className="w-48 h-64 mt-[-5rem] border-2 bg-white/50 border-cyan-400 shadow-lg z-50">
                        <img
                            src={project.imageSlider?.[0]?.url}
                            alt={project.title}
                            className="w-full h-full object-cover rounded-md"
                        />
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-6">
                        {/* Project Description */}
                        <h2 className="text-2xl font-semibold mb-4 text-cyan-500">Description</h2>
                        <p className="text-gray-300 leading-relaxed">
                            {project.description}
                        </p>
                    </div>
                </div>
                <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* Category Section */}
                    <div className="p-4 bg-[#292038] rounded-lg shadow-md">
                        <h3 className="text-xl font-semibold mb-2 text-cyan-400 ">Skills</h3>
                        <p className="text-gray-300 text-lg font-medium">
                            {project.category}
                        </p>
                    </div>

                    {/* GitHub Link */}
                    <div className="p-4 bg-[#292038] rounded-lg shadow-md flex items-center space-x-4">
                        <h3 className="text-xl font-semibold text-cyan-400">GitHub</h3>
                        <a
                            href={project.githubLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white hover:text-cyan-400 transition duration-300"
                        >
                            <FaGithub className="text-3xl" />
                        </a>
                    </div>
                </div>

                {/* Image Slider */}
                <div className="mt-8 bg-[#292038] rounded-2xl p-4 sm:p-4 ">
                    <h3 className="text-xl text-cyan-400 font-semibold mb-4">Project Images</h3>
                    <p className="text-gray-300 leading-relaxed mb-4">
                        Browse through the project's images by sliding to the left to get a visual understanding of the work. Click on the images to view them in full detail.
                    </p>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={30}
                        freeMode={true}
                        pagination={{
                            clickable: true,
                        }}
                        scrollbar={true}
                        modules={[FreeMode, Pagination]}
                        className="mySwiper flex space-x-4 overflow-x-auto scrollbar-hide">
                        {project.imageSlider && project.imageSlider.length > 0 ? (
                            project.imageSlider.map((image, index) => (
                                <SwiperSlide key={index} className="flex-shrink-0 ">
                                    <div className='flex flex-col justify-center bg-black/20 p-4 md:p-6'>
                                        <div
                                            className="cursor-pointer"
                                            onClick={() => openModal(image)}
                                        >
                                            <img
                                                src={image.url}
                                                alt={image.title}
                                                className="w-full h-full object-cover rounded-lg shadow-md"
                                            />
                                        </div>
                                        <div className='uppercase text-2xl'>

                                            <p className="p-2 text-center font-bold text-pink-800 leading-relaxed">
                                                {image.title}
                                            </p>
                                        </div>

                                    </div>
                                </SwiperSlide>
                            ))
                        ) : (
                            <p className="text-gray-300 leading-relaxed">No images available for this project.</p>
                        )}
                    </Swiper>
                </div>

                {/* Video Section */}
                <div className="mt-8  bg-[#292038] rounded-2xl p-4 sm:p-4 ">
                    <h3 className="text-xl font-semibold mb-4 text-cyan-400">Videos</h3>
                    <p className="text-gray-300 leading-relaxed mb-4">
                        Explore the project's videos for a deeper dive into its features and functionality. Play the
                        videos to see the project in action.
                    </p>
                    <div className=''>

                        {project.videoOfProjects && project.videoOfProjects.length > 0 ? (
                            <Swiper
                                spaceBetween={10}
                                navigation={true}
                                thumbs={{ swiper: null }}
                                modules={[FreeMode, Navigation, Thumbs]}
                                className="mySwiper2"
                            >
                                {project.videoOfProjects.map((video, index) => (
                                    <SwiperSlide key={index} className="flex flex-col items-center">
                                        <div>
                                            <div>

                                                <video
                                                    src={video.url}
                                                    controls
                                                    className="w-full  rounded-lg shadow-md"
                                                />
                                            </div>

                                            <div className='uppercase'>

                                                <p className="mt-2 text-center font-bold text-2xl  text-pink-800 leading-relaxed">{video.title}</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ) : (
                            <p className="text-gray-300 leading-relaxed">No videos available for this project.</p>
                        )}
                    </div>
                </div>

                {/* Modal */}
                {modal.isOpen && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
                        <div
                            className={`relative bg-black/80 border-white border-2 rounded-lg shadow-lg ${
                                modal.isFullscreen ? 'w-full h-full' : 'p-4 w-full max-w-2xl'
                            }`}
                        >
                            <button
                                onClick={closeModal}
                                className="absolute top-2 right-2 text-white bg-red-600 rounded-full w-8 h-8 flex items-center justify-center z-50"
                            >
                                &times;
                            </button>
                            <div className={modal.isFullscreen ? 'h-full' : 'h-[30rem]'}>
                                <img
                                    src={modal.src}
                                    alt={modal.title}
                                    className="w-full h-full object-cover rounded-lg"
                                />
                                <div className="absolute top-4 left-4 text-cyan-400 bg-black/40 border-white/20 border-2 px-4 py-2 rounded text-2xl font-semibold">
                                    {modal.title}
                                </div>
                            </div>
                            <button
                                onClick={toggleFullscreen}
                                className="absolute bottom-4 right-4 text-white bg-gray-700 rounded-full w-10 h-10 flex items-center justify-center z-50"
                            >
                                {modal.isFullscreen ? <AiOutlineFullscreenExit size={20} /> : <AiOutlineFullscreen size={20} />}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProjectDetails;

